var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvailableRules = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.0416667,0.752083333 C15.4570308,0.752083333 15.79375,1.08880251 15.79375,1.50416667 L15.79375,16.5458333 C15.79375,16.9611975 15.4570308,17.2979167 15.0416667,17.2979167 L4.88854167,17.2979167 C3.43476712,17.2979167 2.25625,16.1193995 2.25625,14.665625 L2.25625,3.384375 C2.25625,1.93060046 3.43476712,0.752083333 4.88854167,0.752083333 L15.0416667,0.752083333 Z M14.28925,13.5370833 L4.88854167,13.5375 C4.26549543,13.5375 3.76041667,14.0425788 3.76041667,14.665625 L3.76041667,14.665625 C3.76041667,15.2886712 4.26549543,15.79375 4.88854167,15.79375 L14.2895833,15.79375 L14.28925,13.5370833 Z M14.2895833,2.25625 L4.88854167,2.25625 C4.26549543,2.25625 3.76041667,2.76132877 3.76041667,3.384375 L3.76047571,12.2866187 C4.10237861,12.1242088 4.48484759,12.0333333 4.88854167,12.0333333 L4.88854167,12.0333333 L14.28925,12.0330833 L14.2895833,2.25625 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5.-Index-Builder---Create-New-Methodology---Cards---00",
    transform: "translate(-301.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(299.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(0.100000, 0.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18.05,
    height: 18.05
  }))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvailableRules, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/available_rules.9125f395.svg";
export { ForwardRef as ReactComponent };